import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { SwalButtons } from "source/app/services/Shared/RenderSwal/SwalBody/SwalButtons";

export function CancelIcon({
    setState, loadedFormState,
}: {
    setState: (value: React.SetStateAction<IRootNodeFormState>) => void;
    loadedFormState: IRootNodeFormState;
}) {
    return (
        <SwalButtons.Cancel
            Cancel={() => {
                setState(loadedFormState);
            }}
        />
    );
}
